module.exports = "/images/cert_group.f8caa.png";